import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/lib/i18n";

/**
 * Phase 8.1.c — "Learn how scoring works" modal shown from the
 * empty state. Kept short, beginner-friendly, and explicitly
 * non-advisory. Every value formula here mirrors the deterministic
 * math in :file:`portfolio_service.py`.
 */
export default function ScoringHelpDialog({ open, onOpenChange }) {
  const { t } = useTranslation();
  const rows = [
    { k: t("portfolio.help.row_value_k"), v: t("portfolio.help.row_value_v") },
    { k: t("portfolio.help.row_fv_k"), v: t("portfolio.help.row_fv_v") },
    { k: t("portfolio.help.row_upside_k"), v: t("portfolio.help.row_upside_v") },
    { k: t("portfolio.help.row_score_k"), v: t("portfolio.help.row_score_v") },
    { k: t("portfolio.help.row_risk_k"), v: t("portfolio.help.row_risk_v") },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="portfolio-scoring-help-dialog" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle data-testid="portfolio-scoring-help-title">{t("portfolio.help.title")}</DialogTitle>
          <DialogDescription>{t("portfolio.help.subtitle")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.k} className="rounded-lg border border-white/10 bg-card/40 px-3 py-2.5">
              <div className="text-[11px] uppercase tracking-[0.16em] text-[#3DEBFF]/85 mb-0.5">{r.k}</div>
              <div className="text-sm text-foreground/90">{r.v}</div>
            </div>
          ))}
          <div className="text-xs text-muted-foreground italic" data-testid="portfolio-scoring-help-disclaimer">
            {t("portfolio.help.disclaimer")}
          </div>
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange?.(false)} data-testid="portfolio-scoring-help-close">
            {t("portfolio.help.close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
